import { observable, action, makeObservable } from 'mobx'
import { selectionTypes } from 'constants.js'
import api from 'api.js'

class BulkPointBuffer {
  @observable radius = 10
  @observable invalid = observable.map()
  @observable additional_info = []

  constructor () {
    makeObservable(this)
  }

  get selection () {
    return {
      item: this,
      type: selectionTypes.BULK_POINT_BUFFER,
      data: { focusedInteraction: true }
    }
  }

  validate () {
    this.invalid.clear()
    if (this.radius === null || isNaN(this.radius) || this.radius <= 0) {
      this.invalid.set('radius', 'Please enter a valid radius in kilometers.')
    }
    return this.invalid.size === 0
  }

  @action async add (targetGroupId, dsYear, dsName) {
    if (this.validate()) {
      const result = await api.postBulkBuffer({
        target_group_id: targetGroupId,
        radius: this.radius,
        ds_year: dsYear,
        ds_name: dsName
      })
      return result.data
    }
    return null
  }
}

export default BulkPointBuffer
